// extracted by mini-css-extract-plugin
export default {"psevdoBody":"ExtraWorksView_psevdoBody__taJRH"};